import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowboardNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M31.541 2.87a9.608 9.608 0 1113.588 13.59l-.026.025c-2.272 2.27-4.939 4.574-7.554 6.835l-.025.022c-2.653 2.293-5.252 4.541-7.445 6.734-2.194 2.193-4.441 4.793-6.735 7.446l-.021.024c-2.258 2.613-4.56 5.277-6.827 7.547l-.034.034A9.608 9.608 0 112.874 31.538l.02-.02c2.274-2.271 4.942-4.578 7.56-6.84l.024-.022c2.653-2.294 5.253-4.541 7.446-6.735 2.193-2.193 4.441-4.792 6.734-7.445l.022-.025c2.26-2.614 4.563-5.279 6.83-7.55l.028-.027zm2.123 2.12l-.002.002-.026.027-.002.001c-2.184 2.188-4.423 4.776-6.706 7.418l-.022.025c-.22.256-.442.512-.664.768.798-.1 1.63.098 2.32.608l5.213 3.86a3.7 3.7 0 011.434 3.679l.353-.306c2.643-2.284 5.233-4.524 7.421-6.71l.025-.024a6.608 6.608 0 00-9.344-9.348zM20.045 20.043c-1.301 1.301-2.733 2.615-4.212 3.925a3.223 3.223 0 012.163.783l4.888 4.21a3.704 3.704 0 011.282 3.055c1.266-1.425 2.534-2.804 3.791-4.061a92.635 92.635 0 013.825-3.581 3.694 3.694 0 01-2.83-1.08l-4.587-4.587a3.212 3.212 0 01-.944-2.26 90.33 90.33 0 01-3.376 3.596zm-7.353 6.665l-.226.196-.026.021c-2.644 2.286-5.236 4.528-7.425 6.715l-.02.02a6.608 6.608 0 109.346 9.345l.032-.032c2.183-2.187 4.42-4.773 6.702-7.413l.021-.025.105-.122a3.71 3.71 0 01-3.553-1.216l-4.21-4.888a3.227 3.227 0 01-.746-2.601z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowboardNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowboardNormalLarge;
